import { render, staticRenderFns } from "./ShipmentBox.vue?vue&type=template&id=5b223b5c&scoped=true&"
import script from "./ShipmentBox.vue?vue&type=script&lang=js&"
export * from "./ShipmentBox.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentBox.vue?vue&type=style&index=0&id=5b223b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b223b5c",
  null
  
)

export default component.exports